import React from 'react';
import { useLanguage } from '../context/LanguageContext.jsx';

export function LoadingSpinner({ message }) {
  const { t } = useLanguage();

  return (
    <div className="spinner-container" role="status">
      <div className="spinner"></div>
      <span>{message || t('loading')}</span>
    </div>
  );
}
